import React from 'react';

const DEFAULT_VK = 'https://vk.ru/alexpenglish';
const DEFAULT_TG = 'https://t.me/alexander_english';

/**
 * Text prompt + VK / Telegram links (replaces the old single green Записаться button).
 * Pass either `copy` from getOpenSiteText or individual props / a getText helper.
 */
export default function EnrollContactLinks({
    copy,
    getText,
    prompt,
    vkHref,
    telegramHref,
    vkLabel,
    telegramLabel,
    variant = 'default', // default | compact | onDark | pills
    className = '',
    style,
}) {
    const t = (key, fallback) => {
        if (typeof getText === 'function') return getText(key, fallback);
        return fallback;
    };

    const rawPrompt = (prompt
        ?? copy?.enrollLabel
        ?? t('open_enroll_label', t('home_enroll_prompt', 'Записаться'))).trim();
    const text = /:\s*$/.test(rawPrompt) ? rawPrompt : `${rawPrompt}:`;

    const vk = vkHref
        || copy?.vkLink
        || t('global_vk_link', t('prices_vk_link', DEFAULT_VK));
    const tg = telegramHref
        || copy?.telegramLink
        || t('global_telegram_link', t('prices_telegram_link', DEFAULT_TG));
    const vkText = vkLabel || copy?.vkLabel || t('prices_vk_label', 'ВКонтакте');
    const tgText = telegramLabel || copy?.telegramLabel || t('prices_telegram_label', 'Telegram');

    const isPills = variant === 'pills';
    const isDark = variant === 'onDark';
    const isCompact = variant === 'compact';

    return (
        <div
            className={`enroll-contact-links enroll-contact-links--${variant} ${className}`.trim()}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: isCompact ? '0.35rem 0.5rem' : '0.4rem 0.65rem',
                fontWeight: 700,
                fontSize: isCompact ? '0.9rem' : '1rem',
                color: isDark ? 'rgba(255,255,255,0.88)' : '#334155',
                ...style,
            }}
        >
            <span style={{ fontWeight: 800 }}>{text}</span>
            <a
                href={vk}
                target="_blank"
                rel="noopener noreferrer"
                className={isPills ? 'enroll-contact-links__pill enroll-contact-links__pill--vk' : 'enroll-contact-links__link'}
                style={isPills ? undefined : {
                    color: isDark ? '#93c5fd' : '#4361ee',
                    textDecoration: 'none',
                    fontWeight: 800,
                    borderBottom: `1.5px solid ${isDark ? 'rgba(147,197,253,0.45)' : 'rgba(67,97,238,0.35)'}`,
                }}
            >
                {vkText}
            </a>
            <span style={{ opacity: 0.45, fontWeight: 600 }} aria-hidden="true">·</span>
            <a
                href={tg}
                target="_blank"
                rel="noopener noreferrer"
                className={isPills ? 'enroll-contact-links__pill enroll-contact-links__pill--tg' : 'enroll-contact-links__link'}
                style={isPills ? undefined : {
                    color: isDark ? '#7dd3fc' : '#0ea5e9',
                    textDecoration: 'none',
                    fontWeight: 800,
                    borderBottom: `1.5px solid ${isDark ? 'rgba(125,211,252,0.45)' : 'rgba(14,165,233,0.35)'}`,
                }}
            >
                {tgText}
            </a>
        </div>
    );
}

export { DEFAULT_VK, DEFAULT_TG };
